export default "__VITE_ASSET__B56aCC0___"